import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DTConditionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {sharedCampaigns} from '@cl/shared';
import setCardInState from '../cardStateStorage/setCardInState';

/**
 * Sets up the initial card data for processing by retrieving an existing card or creating a new one.
 * The card is stored in session storage for use by the standalone agent.
 *
 * @param cardId - The ID of the card to retrieve, or 0/undefined to create a new card
 * @param defaultCardFactory - A factory function that creates a default card structure for new cards
 * @throws Error if the specified cardId doesn't exist in the campaign
 */
export default function setupCardProcessingData<T extends DTConditionNode>(
  cardId: number | undefined,
  defaultCardFactory: () => T,
) {
  const resolvedCardId = cardId ?? NO_NODE_ID;
  let currentCard: T;

  // If cardId is provided, get the card from the state, otherwise create a new card
  // In any case, set the card in the session storage
  if (!!resolvedCardId) {
    currentCard = sharedCampaigns.nodesRef.value[resolvedCardId] as T;

    if (!currentCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    setCardInState(currentCard);
  } else {
    currentCard = defaultCardFactory();
    setCardInState(currentCard);
  }
}
